export default __webpack_public_path__ + "static/media/4.241f1fd3.jpg";